import { render, staticRenderFns } from "./InfoPopover.vue?vue&type=template&id=6080598a&scoped=true"
import script from "./InfoPopover.vue?vue&type=script&lang=js"
export * from "./InfoPopover.vue?vue&type=script&lang=js"
import style0 from "./InfoPopover.vue?vue&type=style&index=0&id=6080598a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080598a",
  null
  
)

export default component.exports